module.exports = __webpack_public_path__ + "img/premium-yield.6c336a2a.svg";